"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EyeClosed = function EyeClosed(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("path", {
    d: "M4.16597 12.5C6.0664 15.0301 9.09201 16.6667 12.4999 16.6667C15.9079 16.6667 18.9335 15.0301 20.8339 12.5",
    stroke: props.foregroundColor,
    strokeWidth: "0.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }));
};

EyeClosed.defaultProps = {
  altText: "EyeClosed",
  foregroundColor: "#2D5AB4"
};
EyeClosed.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = EyeClosed;
exports.default = _default;